import { trackStructuredEvent } from "./TrackingUtil";
import { TrackingTags } from "../datatypes/Tracking";
import { PageType } from "../datatypes/PageType";

const nameString = "search.";

// result events
export function trackSearchResult(query: string, regularResults: number, favouriteResults: number) {
    const sanitizedQuery = query ? query.toLowerCase() : query;
    const tags = { query: sanitizedQuery, regularResults, favouriteResults };
    const structuredData = { tags };
    trackStructuredEvent(nameString + "result", structuredData);
}

// filter events
function trackSearchFilter(tags: TrackingTags) {
    const structuredData = { tags };
    trackStructuredEvent(nameString + "filter", structuredData);
}

export function trackChooseCategory(name: string, query: string) {
    const sanitizedQuery = query ? query.toLowerCase() : query;
    const tags = { type: "chooseCategory", name, query: sanitizedQuery };
    trackSearchFilter(tags);
}

export function trackChooseFacet(key: string, name: string, newState: boolean) {
    const tags = { type: "chooseFacet", key, name, selected: newState };
    trackSearchFilter(tags);
}

export function trackChangeRangeFacet(
    key: string,
    minValue: number | null | undefined,
    maxValue: number | null | undefined
) {
    const tags = { type: "changeRangeFacet", key: key, minValue: minValue, maxValue: maxValue };
    trackSearchFilter(tags);
}

export function trackFilterFacets(query: string) {
    const tags = { type: "filterFacets", query: query };
    trackSearchFilter(tags);
}

export function trackDeselectFacet(key: string) {
    const tags = { type: "deselectFacet", key: key };
    trackSearchFilter(tags);
}

export function trackDeselectAllFacets() {
    const tags = { type: "deselectAllFacets" };
    trackSearchFilter(tags);
}

export function trackSearchFilterPanel(query: string) {
    const sanitizedQuery = query ? query.toLowerCase() : query;
    const tags = { type: "searchFilterPanel", query: sanitizedQuery };
    trackSearchFilter(tags);
}

// next events
function trackSearchNext(tags: TrackingTags) {
    const structuredData = { tags };
    trackStructuredEvent(nameString + "next", structuredData);
}

export function trackNextPage(pageType: PageType, pageNumber: number) {
    const tags = { type: "page", pageType, pageNumber };
    trackSearchNext(tags);
}

// visible events, e.g. toggling the favorite box
function trackVisibility(tags: TrackingTags) {
    const structuredData = { tags };
    trackStructuredEvent(nameString + "visible", structuredData);
}

export function trackToggleFacetGroup(key: string, type: string, visible: boolean) {
    const tags = { type: "toggleFacetGroup", key, typeOfFacet: type, visible };
    trackVisibility(tags);
}

export function trackToggleCategoryTree(visible: boolean) {
    const tags = { type: "toggleCategoryTree", visible };
    trackVisibility(tags);
}

export function trackToggleSearchField(visible: boolean) {
    const tags = { type: "toggleSearchField", visible };
    trackVisibility(tags);
}
